import React from "react";
import { motion } from "framer-motion";
import "../CSS/Profile.css";
import "../CSS/Global.css";
import CallToAction from "./CallToAction";
import profileImage from "./../Img/profile.jpg";

const scrollReveal = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

const Profile = () => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.section
        className="profile-hero-section"
        variants={scrollReveal}
      >
        <div className="container">
          <div className="profile-two-columns">
            <motion.div
              className="profile-left-col"
              variants={scrollReveal}
            >
              <motion.div
                className="profile-photo-container"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img
                  src={profileImage}
                  alt="Surendra Pal - Director, MoneyVision"
                  className="profile-photo"
                  loading="lazy"
                />
              </motion.div>
              <motion.h1 className="profile-name" variants={scrollReveal}>
                Surendra Pal
              </motion.h1>
              <motion.h2 className="profile-title" variants={scrollReveal}>
                Director – MoneyVision
              </motion.h2>
            </motion.div>

            <motion.div
              className="profile-right-col"
              variants={scrollReveal}
            >
              <p className="about-text">
                With 18+ years of experience in Banking, Financial Services, Loan
                Distribution, Mutual Funds, and Insurance, I have built a strong
                track record of driving business growth, managing high-value
                portfolios, developing strategic partnerships, and leading
                high-performing teams.
              </p>
              <p className="about-text">
                I specialize in Home Loans, Loan Against Property (LAP), Working
                Capital, Project Funding, Mortgage Solutions, Business Loans,
                Personal Loans, and Financial Advisory. My expertise lies in
                building and nurturing strong relationships with banks, NBFCs,
                builders, brokers, real estate professionals, and corporate
                clients.
              </p>
              <p className="about-text">
                My approach combines market knowledge, strategic planning,
                relationship management, and execution excellence to create
                sustainable business growth while delivering the right financial
                solutions to individuals and businesses.
              </p>
            </motion.div>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="philosophy-section profile-section"
        variants={scrollReveal}
      >
        <div className="container">
          <motion.div variants={scrollReveal}>
            <h3>My Philosophy</h3>
            <blockquote className="philosophy-quote">
              “Make financial solutions simple, transparent, accessible, and
              convenient for every customer.”
            </blockquote>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="services-grid-section believe-section"
        variants={scrollReveal}
      >
        <div className="container">
          <motion.div variants={scrollReveal}>
            <h3>What I Believe</h3>
            <p className="profile-prose">
              For me, funding is not simply about completing a transaction.
            </p>
            <p className="profile-prose">
              It is about understanding the customer&apos;s:
            </p>
            <ul className="profile-list">
              <li>Financial position</li>
              <li>Requirements and objectives</li>
              <li>Repayment capacity</li>
              <li>Business or personal circumstances</li>
              <li>Long-term financial goals</li>
            </ul>
            <p className="profile-prose">
              The right financial solution should be suitable, transparent, and
              structured around the customer&apos;s individual needs.
            </p>
            <p className="profile-prose">
              My objective is to simplify the financial journey, provide the
              right guidance, and help customers make better-informed financial
              decisions.
            </p>
          </motion.div>
        </div>
      </motion.section>

      <motion.section
        className="vision-section profile-section"
        variants={scrollReveal}
      >
        <div className="container">
          <motion.div variants={scrollReveal}>
            <h3>My Vision</h3>
            <p className="profile-prose">
              At MoneyVision, I am building a trusted financial solutions
              platform where individuals and businesses can access the right
              financial guidance across loans, insurance, investments, and other
              financial solutions.
            </p>
            <p className="profile-prose">Our long-term vision is:</p>
            <div className="vision-2030">
              <p className="vision-2030-label">MoneyVision 2030</p>
              <p className="vision-2030-statement">
                “We will transform the financial lives of 5,000 families—because
                everyone deserves a better life, greater financial security, and
                a brighter future.”
              </p>
            </div>
            <p className="profile-prose">
              For me, this vision represents the bigger purpose behind
              MoneyVision:
            </p>
            <p className="vision-tagline">
              Better Guidance. Better Access. Better Financial Decisions. Better
              Lives.
            </p>
            <p className="profile-prose">
              MoneyVision is built on the belief that financial solutions should
              not be complicated.
            </p>
            <p className="profile-prose">
              With the right guidance and access to the right solutions,
              individuals, families, and businesses can take confident steps
              toward a more secure and brighter financial future.
            </p>
          </motion.div>
        </div>
      </motion.section>

      <CallToAction />
    </motion.div>
  );
};

export default Profile;
